import { translateX } from 'utils/helpers';
import appService from 'services/appService';
import { Flex, Table, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
  FormButton,
  JarvislyEditViewRemoveItem,
} from 'components/jarvisly-components/others/FormComponents';
import axiosService from 'services/axiosService';

// COMPONENT *******************************************************************
// *****************************************************************************
const BusinessAreaTab = props => {
  // providers context ---------------------------------------------------------

  // props deconstruction ------------------------------------------------------
  const {
    setShowBusinessAreaModal,
    setSelectedRecord,
    refreshParameters,
    parameters,
    setIsWorking,
  } = props;

  // local variables I ----------------------------------------------------------
  const entityParameters = parameters?.entityParameters || {};
  const tableColumns = buildTableColumns();

  // component states -----------------------------------------------------------

  // local variables II ---------------------------------------------------------

  // hooks ---------------------------------------------------------------------

  // METHODS -------------------------------------------------------------------
  const onAdd = () => {
    setShowBusinessAreaModal(true);
  };
  const onEdit = record => {
    setSelectedRecord(record);
    setShowBusinessAreaModal(true);
  };

  const onDelete = async record => {
    setIsWorking(true);
    const axiosOptions = {
      url: `/v1/entity-parameters/add-to-set/${entityParameters?._id}/$pull/businessArea._id`,
      data: {
        _id: record?._id,
      },
    };

    appService.message('s', 'saved_parameters', 'onSave');
    await axiosService.put(axiosOptions);

    refreshParameters(true);
  };

  // local variables III --------------------------------------------------------

  // UI COMPONENT --------------------------------------------------------------
  return (
    <>
      <Table
        rowKey="_id"
        columns={tableColumns.filter(x => !x.hidden)}
        dataSource={entityParameters?.businessArea || []}
        pagination={false}
        disabled={false}
        size="small"
      />

      <Flex justify="center">
        <FormButton
          title="add_area_activy"
          className="m-3"
          style={{ width: 'fit-content' }}
          icon={<PlusOutlined />}
          disabled={false}
          onClick={onAdd}
        />
      </Flex>
    </>
  );

  // INTERNAL FUNCTIONS ========================================================
  // ===========================================================================
  function buildTableColumns() {
    return [
      {
        title: translateX('name'),
        dataIndex: 'name',
        className: 'text-truncate',
        render: (_, record) => {
          return (
            <Tag key={record._id} color={record?.backColor}>
              <span
                className="text-uppercase"
                style={{ color: record?.foreColor }}
              >
                {record?.label}
              </span>
            </Tag>
          );
        },
      },
      {
        title: translateX('actions'),
        dataIndex: 'actions',
        width: 120,
        className: 'text-center',
        render: (_, record) => {
          return (
            <JarvislyEditViewRemoveItem
              size="small"
              onEdit={onEdit}
              onDelete={onDelete}
              record={record}
              isDisabled={false}
              deleteTitle={translateX(
                'remove_this_item',
                ['%ITEM%'],
                ['contact'],
              )}
            />
          );
        },
      },
    ].filter(x => !x.hidden);
  }
};

export default BusinessAreaTab;
